module.exports = __webpack_public_path__ + "img/AWeber.6ffb3e86.svg";